import urls from "../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../utils/service";

export async function addUserLeave(body: any) {
    try {
      const callParams = await getCallParams("PUT", body);
      const response = await makeCall(
        urls.ADDUSERLEAVE,
        callParams
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
  